import ReactGA from "react-ga";

export function initGA() {
  ReactGA.initialize("UA-00000000-00");
}
